import React from 'react';
import styled from 'astroturf/react';

import $image_url from 'js/utils/image_url';
import { currentUser } from 'js/utils/user';
import DoubleDigitCountBubble from 'js/header/FocusedNav/DoubleDigitCountBubble';
import AccountAvatarUpsellBadge from 'js/header/FocusedNav/AccountAvatarUpsellBadge';

const PositionedDoubleDigitCountBubble = styled(DoubleDigitCountBubble)`
  position: absolute;
  top: 2px;
  right: -10px;
`;

const UserButton = styled.button<{ small?: boolean }>`
  position: relative;
  height: 42px;
  padding: 0;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  background: transparent;
  border: none;
  color: #0645b1;
  cursor: pointer;

  &:hover,
  &:active,
  &:visited {
    color: #0645b1;
  }
  &:hover,
  &:focus {
    background: transparent;
    color: #0645b1;
  }

  display: flex;
  align-items: center;
`;

// Wraps the avatar button so the upsell badge (an <a>) is a SIBLING of the
// <button>, not a child — interactive content inside a button is invalid HTML.
// position:relative keeps it the offset parent for the badge, placement unchanged.
const AvatarButtonWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

const ButtonProfilePic = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
`;

type Props = {
  count: number;
  menuOpen: boolean;
  setMenuOpen: (openness: boolean) => void;
  /** Whether the current user is premium. Gates the upsell badge. */
  isPremium?: boolean;
  /**
   * Autotest `accountAvatarUpsell` surface (arm v_account_avatar_upsell). When
   * true and the user is non-premium, render a small additive "Upgrade" badge on
   * the avatar button. Defaults to false (CONTROL = today's rendering exactly).
   */
  accountAvatarUpsell?: boolean;
};

const AccountMenuButton = ({
  count,
  menuOpen,
  setMenuOpen,
  isPremium = false,
  accountAvatarUpsell = false,
}: Props) => {
  const toggle = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <AvatarButtonWrapper>
      <UserButton onClick={toggle} aria-pressed={menuOpen}>
        {currentUser != null && (
          <ButtonProfilePic src={$image_url(currentUser.photo)} />
        )}
        <PositionedDoubleDigitCountBubble count={count} />
      </UserButton>
      {accountAvatarUpsell && !isPremium && <AccountAvatarUpsellBadge />}
    </AvatarButtonWrapper>
  );
};

export default AccountMenuButton;
